'use client';

/** @jsxRuntime classic */
/** @jsx jsx */

import { jsx } from '@emotion/react';
import Button from '@egalite/ui/Buttons';
import ErrorList from '@egalite/ui/ErrorList';
import SelectField from '@egalite/ui/Form/SelectField';
import { useNotification } from '@egalite/ui/IncluiPCD/NotificationProvider';
import Loading from '@egalite/ui/Loading';
import Typography from '@egalite/ui/Typography';
import Cookies from 'js-cookie';
import { useRouter, useSearchParams } from 'next/navigation';
import { FC, useEffect, useState } from 'react';
import authFetch from '../../lib/auth/authFetch';
import useForm from '../../lib/hooks/useForm';
import validationSchema, { initialValues } from '../../lib/validation/candidate/disabilityData';
import ButtonsPages from './legacy_blocks/ButtonsPages';
import FormPage from './legacy_blocks/CandidateFormPage';
import save from './save';

const DisabilityDataForm: FC<{ edit?: boolean; onSuccess?: () => void }> = ({ edit = false, onSuccess = null }) => {
	const notification = useNotification();
	const [loadingData, setLoadingData] = useState(true);
	const [candidateData, setCandidateData] = useState(null);
	const [disabilityData, setDisabilityData] = useState(initialValues);
	const searchParams = useSearchParams();
	const router = useRouter();

	const [formController, getFieldProps, { loading, submitting, success, errors, data }] = useForm({
		initialValues: disabilityData,
		validationSchema,
		mutation: data => save('/api/v1/candidate/disabilityData', data),
		onSuccess:
			onSuccess != null
				? () => onSuccess()
				: () => {
						router.push(
							`/candidato/form/disabilityDataDescription?n=${disabilityData.id ?? candidateData.disability.length}`,
						);
				  },
	});

	useEffect(() => {
		if (loadingData) {
			authFetch('/api/v2/candidate/profile', Cookies.get('token'))
				.then(res => res.json())
				.then(data => {
					setLoadingData(false);
					if (data.success === true) {
						setCandidateData(data.data);
						const n = searchParams.get('n');
						if (n == null) {
						} else if (data.data.disability && data.data.disability[n] != null) {
							const disabilityData = data.data.disability[n];
							const newValues = Object.keys(initialValues).reduce((acc, key) => {
								acc[key] = disabilityData[key] ?? initialValues[key];
								return acc;
							}, {});
							(newValues as typeof initialValues).id = n;
							setDisabilityData(newValues as typeof initialValues);
						} else {
							notification.error('Erro ao carregar dados do candidato');
						}
					} else {
						notification.error('Erro ao carregar dados do candidato');
					}
				});
		}
	}, [formController, router, loadingData, notification, searchParams]);

	if (loadingData) {
		return <Loading fullScreen={true}>carregando dados</Loading>;
	}

	return (
		<FormPage
			actualStep={4}
			formActualStep={1}
			formTotalSteps={2}
			progress={50}
			formTitle={'Dados da Deficiência'}
			// previousForm="/"
			showStepsMenu={false}
			// showBackButton={false}
			modal={edit}
		>
			<form onSubmit={formController.handleSubmit}>
				<div className="mb-16 md:mb-24">
					{edit ? null : (
						<Typography variant="headline-5" className="text-brand-main mb-12">
							Minha deficiência
						</Typography>
					)}

					<SelectField
						id="disabilityType"
						label={'Tipo da deficiência'}
						options={[
							{ value: 'Deficiência Auditiva', label: 'Deficiência Auditiva' },
							{ value: 'Deficiência Física', label: 'Deficiência Física' },
							{ value: 'Deficiência Intelectual', label: 'Deficiência Intelectual' },
							{ value: 'Deficiência Psicossocial', label: 'Deficiência Psicossocial' },
							{ value: 'Deficiência Visual', label: 'Deficiência Visual' },
							{ value: 'Transtorno do Espectro Autista', label: 'Transtorno do Espectro Autista' },
							{ value: 'Reabilitado do INSS', label: 'Reabilitado do INSS' },
						]}
						{...getFieldProps('disabilityType')}
					/>
					<ErrorList errors={formController.errors} touched={formController.touched} />

					{errors != null &&
						errors.map((err, index) => (
							<Typography key={`err-${index}`} variant="body2" color="error.dark">
								{err}
							</Typography>
						))}
					<div className="md:mt-24 mt-16">
						{edit ? (
							<Button type="submit" variant="primary" className="w-full">
								Salvar
							</Button>
						) : (
							<ButtonsPages
								submitDisabled={submitting}
								previousForm={'/candidato/form/professionalDataExperienceIndex'}
								hideBack={edit}
							/>
						)}
					</div>
				</div>
			</form>
		</FormPage>
	);
};

export default DisabilityDataForm;
